import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useGetList, useRecordContext } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { AutocompleteMultiselectInput, TextInput } from 'shared/react-admin/Inputs';
import { ReferenceArrayInput } from 'shared/react-admin/ReferenceInputs';
import { Currency } from 'types/embedded/currency';
import { Merchant } from 'types/embedded/merchant';

export const MerchantShowCommissionsListFilterValues: React.FC = () => {
  const translate = useTypedTranslate();
  const { getValues } = useFormContext();
  const { data: commissionStatuses } = useGetList('commission_statuses');
  const record = useRecordContext<Merchant>();

  return (
    <>
      <TextInput
        helperText={false}
        key="name"
        label={translate('app.filter.name')}
        resettable
        source="name"
        variant="outlined"
      />
      <AutocompleteMultiselectInput
        defaultValue={getValues('status')}
        helperText={false}
        label={translate('app.filter.statuses')}
        name="status"
        optionText="description"
        optionValue="value"
        options={commissionStatuses || []}
      />
      <ReferenceArrayInput
        filter={{ 'commissions.merchant': record?.id }}
        perPage={100}
        reference="providers"
        sort={{ field: 'name', order: 'ASC' }}
        source="provider"
      >
        <AutocompleteMultiselectInput
          clearOnBlur={false}
          filterToQuery={(searchText: string) => ({ name: searchText })}
          helperText={false}
          label={translate('app.filter.providers')}
          name="provider"
          optionText="name"
        />
      </ReferenceArrayInput>
      <ReferenceArrayInput
        filter={{ active: true }}
        perPage={50}
        reference="currencies"
        source="currency.id"
      >
        <AutocompleteMultiselectInput
          filterToQuery={(searchText: string) => ({ currency: searchText })}
          getOptionLabel={(record: Currency) => `${record?.alphaCode}, ${record?.name}`}
          helperText={false}
          label={translate('app.filter.currencies')}
          name="currency.id"
        />
      </ReferenceArrayInput>
      <ReferenceArrayInput perPage={100} reference="transaction_types" source="transactionTypes">
        <AutocompleteMultiselectInput
          helperText={false}
          label={translate('app.commissions.transactionTypes')}
          name="transactionTypes"
          optionText="name"
        />
      </ReferenceArrayInput>
      <TextInput
        helperText={false}
        label={translate('app.merchantCommissions.feeId')}
        resettable
        source="id"
        variant="outlined"
      />
      <TextInput
        helperText={false}
        label={translate('app.merchantCommissions.parentFeeId')}
        resettable
        source="parent.id"
        variant="outlined"
      />
    </>
  );
};
